var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-row',{staticClass:"DutyActivityNoLineEnd_Default",attrs:{"dense":""}})}
var staticRenderFns = []

export { render, staticRenderFns }